import { InjectionToken } from "@angular/core";

export const TIME_FORMAT = new InjectionToken<string>("Time format used for datetime module things");
